import Link from "next/link";

import { TwinLiveMark } from "@/components/app/twin/twin-live-mark";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";

/**
 * The Twin's mark in its disc: the glyph for starting a session, wherever one
 * starts. It breathes only while a session is being started.
 */
export function AskTwinMark({ active = false }: { active?: boolean }) {
  return (
    <span aria-hidden className="size-3.5 shrink-0 overflow-hidden rounded-full">
      <TwinLiveMark bleed active={active} className="size-full" />
    </span>
  );
}

/**
 * The one way to start a session: "Ask" beside the Twin's mark, as an outline
 * button. `title` says what the new session will be about; `compact` keeps
 * only the mark below `sm`, where a header's row is short of room.
 */
export function AskTwinLink({
  href,
  title,
  compact = false,
  size = "sm",
  className,
}: {
  href: string;
  title: string;
  compact?: boolean;
  size?: "xs" | "sm";
  className?: string;
}) {
  return (
    <Link
      href={href}
      aria-label={title}
      title={title}
      className={cn(buttonVariants({ variant: "outline", size }), "shrink-0", className)}
    >
      <AskTwinMark />
      <span className={compact ? "hidden sm:inline" : undefined}>Ask</span>
    </Link>
  );
}
